// extracted by mini-css-extract-plugin
module.exports = {"Emojify":"bbt_a bht_g"};